module.exports = __webpack_public_path__ + "img/searchIcon.fbf3c4f1.svg";